import { homedir } from 'os';
import { mkdir, writeFile } from 'fs/promises';
import path from 'path';
import { cosmiconfig } from 'cosmiconfig';

/*
Precedence of CLI configuration (from highest to lowest):
per cli execution: pass config file (--config /path/to/.hotgluerc) option with your command
per project: load from current project's package.json or a config folder in any folder in the path (i.e. /path/to/project/.hotgluerc)
per user: ~/.hotglue/config.yaml
any built-in or default config settings
*/

const staticOptions = {
  hg: {
    appName: 'hotglue',
    clientApiBaseUri: process.env.HOTGLUE_CLIENT_API_BASE_URI || 'https://api.hotglue.com',
    defaultConfigFileName: 'config.yaml',
  },
};

const defaultOptions = {
  // absolute path or a relative path using dot notation only
  // downloadFolder: path.resolve(process.cwd(), 'downloads'),
};

const getProfileConfigFilePath = () =>
  path.resolve(homedir(), `.${staticOptions.hg.appName}`, staticOptions.hg.defaultConfigFileName);

const writeConfigFile = async (file, data) => {
  await mkdir(path.dirname(file), { recursive: true });
  await writeFile(file, data);
};

const getProfileConfig = async () => {
  const { appName } = staticOptions.hg;

  try {
    const result = await cosmiconfig(appName).load(getProfileConfigFilePath());
    return result || {};
    // return { ...result.config };
  } catch (err) {
    // no profile config found; app not configured
    return {};
  }
};

const getProjectConfig = async () => {
  const { appName } = staticOptions.hg;

  const cosmic = cosmiconfig(appName, {
    searchPlaces: [
      // primary
      `${appName}.yaml`,
      `.${appName}.yaml`,
      `.${appName}rc.yaml`,
      `.${appName}rc.yml`,
      // secondary
      `.${appName}rc`,
      `.${appName}rc.json`,
      `.${appName}rc.js`,
      // `package.json`,
    ],
    // loaders: [],
    // packageProp: `${appName}`,
    // stopDir: '',
    // cache: true,
    // transform: (res) => res
  });

  try {
    const result = await cosmic.search();
    return result || {};
    // return (result && result.config) || {};
  } catch (err) {
    console.log(err); // use debug()
    throw new Error(`Malformed configuration file: ${err.message}`);
  }
};

const getCombinedConfig = async () => {
  const profileConfig = await getProfileConfig();

  const projectConfig = await getProjectConfig();

  const result = { ...defaultOptions, ...profileConfig.config, ...projectConfig.config };
  // todo: post-process config (i.e. template replacement)
  return result;
};

export {
  getProfileConfigFilePath,
  getProfileConfig,
  getProjectConfig,
  getCombinedConfig,
  writeConfigFile,
  staticOptions,
};
